import React from 'react';
import { Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';
import styles from './GlobalLoader.module.css';

/**
 * GlobalLoader component for displaying a global loading indicator.
 *
 * This component renders a loading indicator overlay with a "Loading" message and animation.
 *
 * @component
 */
export const GlobalLoader = (props) => {
  return (
    <>
      {props.title ? (
        <div className={`${styles.loaderBackground} d-flex justify-content-center`} data-testid="global-loader">{props.title}</div>
      ) : (
        <div className={`${styles.loaderBackground} d-flex justify-content-center`} data-testid="global-loader">
          <Spinner className={styles.spinner} animation="border" variant="danger" />
        </div>
      )}
    </>
  );
};
GlobalLoader.propTypes = {
  /**
   * The title or text to display on the button.
   */
  title: PropTypes.string,
};

export default GlobalLoader;
